import React from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { getWindow } from "ssr-window";
import { connect } from "react-redux";

import url from "@/utils/url";
import { authStateEnum } from "@/utils/enum";

class BackButton extends React.Component {
  // 戻る
  backClick = () => {
    const {
      history: { goBack, replace },
      state,
    } = this.props;
    if (getWindow()?.history?.state?.referrer) {
      goBack();
    } else {
      if (state === authStateEnum.notCertified) {
        replace(url.lp);
      } else {
        replace(url.home);
      }
    }
  };

  render() {
    const { title } = this.props;
    return (
      <div onClick={this.backClick} className="back-button-container" tabIndex="0">
        <img alt="" src={require("@/assets/images/btn_back.svg")} />
        <span>{title || this.props.t("TWBC0001_back")}</span>
      </div>
    );
  }
}

BackButton.propTypes = {
  title: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    state: state?.user?.authState,
  };
};

export default connect(mapStateToProps)(
  withRouter(withTranslation()(BackButton))
);
